import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { MapContainer, useMap } from "react-leaflet";
import { MapZoomHandler, MapEventHandler } from "../Map/components";
import { LayoutEditLegend } from "./LayoutEditLegend";
import { getCenterPoint } from "..";

const FlyToMapCenter = ({ center }) => {
  const map = useMap();
  const site_features = useSelector((state) => state.inputs.site_features);

  useEffect(() => {
    if (map) {
      const site_center = getCenterPoint(Object.values(site_features), true);
      // console.log("site center", site_center);
      map.setView(site_center, 16, { animate: true });
    }
  }, [map, center]);

  return null;
};

const LayoutEditorMap = ({ children }) => {
  const map_center = useSelector((state) => state.inputs.map_center);

  // useEffect(() => {
  //   console.log("map center", map_center);
  // }, [map_center]);

  return (
    <MapContainer
      id="editor-map"
      className="editor-map"
      key="editor-map"
      center={map_center}
      zoom={16}
      zoomSnap={0.15}
      animate={true}
      doubleClickZoom={false}
      zoomControl={false}
      worldCopyJump={true}
      attributionControl={false}
      minZoom={2}
      maxZoom={20}
    >
      <FlyToMapCenter center={map_center} />
      <MapEventHandler />
      <MapZoomHandler position="topright" />
      <LayoutEditLegend position="topleft" />
      {children}
    </MapContainer>
  );
};

export { LayoutEditorMap };
